<template>
  <div>
    <NavbarView :rainbow="false" />

    <!-- BACK BUTTON -->
    <button class="back-button" @click="$router.back()">
      ← Back
    </button>

    <h1>DATA PLOTS</h1>

    <!-- INTRO -->
    <div class="intro-wrapper">
      <p class="intro-text">
        Just some data visualizations made with TouchDesigner. Some of them come with tutorials to help you recreate them.
        All you find here has been done in my free time for no particular purpose, just chilling and learning.
        If you are interested in geographical data sources →
      </p>

      <router-link to="/td/geo-data" class="geo-button">
        Geographical data
      </router-link>
    </div>

    <!-- TUTORIALS -->
    <div v-if="tutorials.length">
      <h2 class="section-title">TUTORIALS</h2>

      <div class="td-grid">
        <div v-for="item in tutorials" :key="item.id" class="td-card-wrapper">
          <div class="td-title">{{ item.title }}</div>

          <a
            v-if="item.url_project"
            :href="item.url_project"
            target="_blank"
            rel="noopener noreferrer"
            class="media-link"
          >
            <img
              v-if="item.type === 'image' && item.url_content"
              :src="item.url_content"
              :alt="item.title"
            />
            <video
              v-else-if="item.type === 'video' && item.url_content"
              :src="item.url_content"
              muted
              autoplay
              loop
              playsinline
            />
            <div v-else class="placeholder">No preview</div>
          </a>

          <!-- ICONS -->
          <div class="td-icons">
            <a
              v-if="item.url_youtube"
              :href="item.url_youtube"
              target="_blank"
              rel="noopener noreferrer"
              title="Watch on YouTube"
            >
              <img
                src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/youtube.svg"
                alt="YouTube"
              />
            </a>

            <a
              v-if="item.url_project"
              :href="item.url_project"
              target="_blank"
              rel="noopener noreferrer"
              title="View project files"
            >
              <img
                src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/gitlab.svg"
                alt="GitLab"
              />
            </a>
          </div>

          <div v-if="item.description" class="td-description">
            {{ item.description }}
          </div>
        </div>
      </div>
    </div>

    <!-- PLOTS -->
    <div v-if="nonTutorials.length">
      <h2 class="section-title">PLOTS</h2>

      <div class="td-grid">
        <div v-for="item in nonTutorials" :key="item.id" class="td-card-wrapper">
          <div class="td-title">{{ item.title }}</div>

          <a
            v-if="item.url_project"
            :href="item.url_project"
            target="_blank"
            rel="noopener noreferrer"
            class="media-link"
          >
            <img
              v-if="item.type === 'image' && item.url_content"
              :src="item.url_content"
              :alt="item.title"
            />
            <video
              v-else-if="item.type === 'video' && item.url_content"
              :src="item.url_content"
              muted
              autoplay
              loop
              playsinline
            />
            <div v-else class="placeholder">No preview</div>
          </a>

          <!-- ICONS -->
          <div class="td-icons">
            <a
              v-if="item.url_youtube"
              :href="item.url_youtube"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/youtube.svg"
                alt="YouTube"
              />
            </a>

            <a
              v-if="item.url_project"
              :href="item.url_project"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/gitlab.svg"
                alt="GitLab"
              />
            </a>
          </div>

          <div v-if="item.description" class="td-description">
            {{ item.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarView from '../../NavbarView.vue';

export default {
  name: 'GeometricWorldsView',
  components: { NavbarView },

  data() {
    return {
      items: [],
    };
  },

  computed: {
    tutorials() {
      return this.items.filter(item => item.is_tutorial);
    },
    nonTutorials() {
      return this.items.filter(item => !item.is_tutorial);
    },
  },

  mounted() {
    fetch('https://tommella-general-storage-83d44de1134b.herokuapp.com/apps/td/dataplots/')
      .then(res => res.json())
      .then(data => {
        this.items = data;
      })
      .catch(err => {
        console.error('Fetch failed:', err);
      });
  },
};
</script>


<style scoped>
h1 {
  text-align: center;
  margin: 100px 0 30px;
  font-size: 2.5em;
  color: #176219;
}

/* BACK BUTTON */
.back-button {
  position: fixed;
  top: 90px;
  left: 30px;
  background: #eee;
  border: none;
  color: #333;
  padding: 8px 14px;
  border-radius: 20px;
  font-size: 0.9rem;
  cursor: pointer;
  z-index: 10;
}

.back-button:hover {
  background: #ddd;
}

/* INTRO */
.intro-wrapper {
  max-width: 1000px;
  margin: 0 auto 50px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.intro-text {
  flex: 1;
  font-size: 1.1rem;
  line-height: 1.6;
  color: #444;
}

.geo-button {
  white-space: nowrap;
  padding: 12px 18px;
  border-radius: 8px;
  background: #176219;
  color: white;
  font-weight: 600;
  text-decoration: none;
}

.geo-button:hover {
  background: #0f4d14;
}

/* GRID */
.td-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 60px 60px;
}

.td-title {
  margin: 18px 0;
  font-weight: 700;
  font-size: 1.5rem;
  text-align: center;
}

.media-link,
.placeholder {
  width: 100%;
  aspect-ratio: 1280 / 720;
  border-radius: 10px;
  overflow: hidden;
  display: block;
}

.media-link img,
.media-link video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #111;
  color: white;
}

/* ICONS */
.td-icons {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-top: 10px;
}

.td-icons img {
  width: 18px;
  height: 18px;
  opacity: 0.6;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.td-icons img:hover {
  opacity: 1;
  transform: scale(1.1);
}

.td-description {
  margin-top: 12px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 8px;
  font-size: 0.9rem;
}

/* On screens smaller than 768px (typical smartphone) */
@media (max-width: 768px) {
  .td-grid {
    grid-template-columns: 1fr; /* 1 column */
    gap: 20px; /* smaller gap for mobile */
    padding: 0 20px 40px;
  }

  .intro-wrapper {
    flex-direction: column;
    text-align: center;
  }

  .back-button {
    top: 70px;
    left: 15px;
  }
}
</style>
